/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Gov_Team_AuditInputs */



/**
* | output |
* | --- |
* | "90 days" |
*
* @param {Compare_Gov_Team_AuditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_gov_team_audit = /** @type {((inputs?: Compare_Gov_Team_AuditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Gov_Team_AuditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("90 Tage")
	return /** @type {LocalizedString} */ ("90 days")
});